import { render, staticRenderFns } from "./GroupDiscount.vue?vue&type=template&id=08a43242&scoped=true"
import script from "./GroupDiscount.vue?vue&type=script&lang=js"
export * from "./GroupDiscount.vue?vue&type=script&lang=js"
import style0 from "./GroupDiscount.vue?vue&type=style&index=0&id=08a43242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a43242",
  null
  
)

export default component.exports